import { useHotkeys, Options } from "react-hotkeys-hook";
import { useMapEditor } from "../../../contexts/MapEditorContext";
import { useEditorShortcuts } from "../EditorShortcutContext/useEditorShortcuts";
import { SHAPE_SELECTION_SHORTCUTS_SCOPE } from "../shortcuts";

export const useShapeSelectionShortcuts = () => {
  const {
    selectedIds,
    deleteShape,
    updateShapes,
    shapes,
    duplicateShape,
    setSelectedIds,
    copySelectedShapes,
  } = useMapEditor();

  const { shortcuts } = useEditorShortcuts();
  const enabled = selectedIds.length > 0;
  const scopes = [SHAPE_SELECTION_SHORTCUTS_SCOPE];
  const preventDefault = true;

  const shortcutOptions: Options = { scopes, enabled, preventDefault };

  const getFirstShape = (event: KeyboardEvent) => {
    event.preventDefault();
    event.stopPropagation();
    return shapes.find((shape) => shape.id === selectedIds[0]);
  };

  useHotkeys(
    shortcuts.shapeSelection.delete,
    () => {
      deleteShape(selectedIds);
    },
    shortcutOptions,
    [selectedIds, shortcuts.shapeSelection.delete],
  );

  useHotkeys(
    shortcuts.shapeSelection.showHide,
    (event) => {
      const firstShape = getFirstShape(event);
      if (!firstShape) return;
      updateShapes(selectedIds, { hidden: !firstShape.hidden });
    },
    shortcutOptions,
    [selectedIds, shortcuts.shapeSelection.showHide],
  );

  useHotkeys(
    shortcuts.shapeSelection.lockUnlock,
    (event) => {
      const firstShape = getFirstShape(event);
      if (!firstShape) return;

      updateShapes(selectedIds, { locked: !firstShape.locked });
    },
    shortcutOptions,
    [selectedIds, shortcuts.shapeSelection.lockUnlock],
  );

  useHotkeys(
    shortcuts.shapeSelection.duplicate,
    (event) => {
      const firstShape = getFirstShape(event);
      if (!firstShape) return;

      const newShapes = duplicateShape(selectedIds);

      if (newShapes) setSelectedIds(newShapes.map((shape) => shape.id));
    },
    shortcutOptions,
    [selectedIds, shortcuts.shapeSelection.duplicate],
  );

  useHotkeys(
    shortcuts.shapeSelection.cut,
    (event) => {
      const firstShape = getFirstShape(event);
      if (!firstShape) return;

      copySelectedShapes();
      deleteShape(selectedIds);
    },
    shortcutOptions,
    [selectedIds, shortcuts.shapeSelection.cut],
  );
};
